import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const MainLayout = ({ formData, onLogout, children }) => {
  const [activeMenu, setActiveMenu] = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsedState] = useState(
    () => localStorage.getItem("sidebar_collapsed") === "true"
  );

  const setIsCollapsed = (val) => {
    setIsCollapsedState((prev) => {
      const next = typeof val === "function" ? val(prev) : val;
      localStorage.setItem("sidebar_collapsed", String(next));
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-zinc-50/60 flex text-zinc-900 font-sans antialiased w-full max-w-full overflow-x-hidden">
      <Sidebar
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        onLogout={onLogout}
      />
      <div
        className={`flex-1 min-w-0 w-full max-w-full transition-all duration-300 overflow-x-hidden ${
          isCollapsed ? "md:pl-16" : "md:pl-64"
        }`}
      >
        <Header
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <main className="p-3 sm:p-4 text-zinc-900 min-h-[calc(100vh-3.5rem)] overflow-x-hidden max-w-full w-full min-w-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
